export const getEnvironment = () => {
  const env = import.meta.env.VITE_APP_ENV;

  if (env === 'main') {
    return 'production';
  } else if (env?.includes('release')) {
    return 'pre-production';
  } else if (env === 'development') {
    return 'development';
  } else {
    return 'local';
  }
};
